import styled from 'styled-components';
import { colors } from '../../constants/colors';

export type TagStatus = 'active' | 'locked' | 'locked-purple' | 'locked-blue' | 'locked-red' | 'locked-orange';

export interface TagProps {
  label: string;
  status: TagStatus;
  textColor?: string;
  backgroundColor?: string;
}

const TagContainer = styled.div<{
  $textColor?: string;
  $backgroundColor?: string;
  $status: TagStatus;
}>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 16px;

  /* Typography styles */
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;

  /* Default styles based on status */
  color: ${({ $textColor, $status }) => {
    if ($textColor) return $textColor;
    switch ($status) {
      case 'active':
        return colors.secondary[3]; // Updated to use secondary.3 (#2D6772)
      case 'locked':
        return colors.neutral.text[3];
      case 'locked-red':
        return colors.other[3];
      case 'locked-orange':
        return colors.orange[2];
      default:
        return colors.neutral.text[3];
    }
  }};

  background-color: ${({ $backgroundColor, $status }) => {
    if ($backgroundColor) return $backgroundColor;
    switch ($status) {
      case 'active':
        return colors.primary[1];
      case 'locked':
        return colors.neutral.bg[3];
      case 'locked-purple':
        return colors.purple[1];
      case 'locked-blue':
        return colors.primary[2];
      case 'locked-red':
        return colors.other[1];
      case 'locked-orange':
        return colors.orange[1];
      default:
        return colors.neutral.bg[3];
    }
  }};
`;

const Tag = ({ label, status, textColor, backgroundColor }: TagProps) => {
  return (
    <TagContainer $textColor={textColor} $backgroundColor={backgroundColor} $status={status}>
      {label}
    </TagContainer>
  );
};

export default Tag;
